import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Route, Routes } from 'react-router-dom';
import { can } from '../../common/Util';
import { Icon } from '../../common/components/Utilities';
import Salaries from './Salaries';
import { CsrfContext, GroupsContext } from '../../common/Context';
import RestrictedContent from '../../common/components/RestrictedContent';
import SupportCsv from '../components/Reports/SupportCsv';
import LocationTimesheetCsv from '../components/Reports/LocationTimesheetCsv';
import SupportEmail from '../components/Reports/SupportEmail';
import TeamVisibility from '../components/Reports/TeamVisibility';
import EngagementReport from '../components/Reports/EngagementReport';
import TaskRunner from '../components/Reports/TaskRunner';

function Reports() {
  return (
    <Routes>
      <Route path="salary/*" element={<Salaries />} />
      <Route path="leadership/visibility" element={<TeamVisibility />} />
      <Route path="engagement" element={<EngagementReport />} />

      <Route
        path="/"
        element={(
          <GroupsContext.Consumer>
            {(groups) => (
              <ReportsList groups={groups} />
            )}
          </GroupsContext.Consumer>
          )}
      />
    </Routes>
  );
}

function ReportsList({ groups }) {
  return (
    <Row>
      <Col md={4}>
        <Card className="mb-4">
          <Card.Header>People</Card.Header>
          <Card.Body>
            {can('leadership') && (
            <a className="btn btn-block btn-outline-primary mb-2 text-left" href="/reports/leadership/visibility">
              <Icon icon="users" variant="fad" append="mr-2" />
              Team Visibility
            </a>
            )}

            <ReportLink href="/reports/engagement" group={groups.OPERATIONS} icon="users">
              Engagement
            </ReportLink>
          </Card.Body>
        </Card>
      </Col>
      <RestrictedContent group={groups.CAN_VIEW_EMPLOYEE_SALARIES}>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Header>Salaries</Card.Header>
            <Card.Body>
              <ReportLink href="/reports/salary/april" group={groups.CAN_VIEW_EMPLOYEE_SALARIES} icon="coins">
                April Salary Review
              </ReportLink>

              <ReportLink href="/reports/salary/october" group={groups.CAN_VIEW_EMPLOYEE_SALARIES} icon="coins">
                October Salary Review
              </ReportLink>

              <ReportLink href="/reports/salary/role" group={groups.OPERATIONS} icon="coins">
                Salary by Role
              </ReportLink>

              <ReportLink href="/users/salaries" group={groups.OPERATIONS} icon="coins">
                Salary by User
              </ReportLink>

              <ReportLink href="/reports/salary/changes" group={groups.OPERATIONS} icon="coins">
                Proposed Salary Changes
              </ReportLink>
            </Card.Body>
          </Card>
        </Col>
      </RestrictedContent>

      <Col md={4}>
        <Card className="mb-4">
          <Card.Header>Time &amp; Productivity</Card.Header>
          <Card.Body>
            <ReportLink href="/reports/timesheets" group={groups.OPERATIONS} icon="clock">
              Check in &amp; Check out
            </ReportLink>

            <ReportLink href="https://projects.g4m.co.uk/dash/weekly" group={groups.OPERATIONS} icon="clock">
              Weekly Time Dashboard
            </ReportLink>

            <ReportLink href="https://projects.g4m.co.uk/timesheets" group={groups.CAN_ACCESS_PROJECTS} icon="clock">
              Timesheets
            </ReportLink>

            <hr />

            <CsrfContext.Consumer>
              {(csrfToken) => (
                <LocationTimesheetCsv groups={groups} csrfToken={csrfToken} />
              )}
            </CsrfContext.Consumer>

          </Card.Body>
        </Card>
      </Col>

      <Col md={4}>
        <Card className="mb-4">
          <Card.Header>People Management</Card.Header>
          <Card.Body>
            <ReportLink href="/reports/objectives" group={groups.OPERATIONS} icon="tasks">
              Objectives
            </ReportLink>

            <ReportLink href="/reviews" group={groups.OPERATIONS} icon="tasks">
              Review Completion
            </ReportLink>

            <ReportLink href="/admin/new-starters" group={groups.OPERATIONS} icon="users">
              New Starters
            </ReportLink>
          </Card.Body>
        </Card>
      </Col>

      <RestrictedContent group={groups.OPERATIONS}>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Header>Leave &amp; Sickness</Card.Header>
            <Card.Body>
              <ReportLink href="/all-leave" group={groups.OPERATIONS} icon="plane-departure">
                All Leave
              </ReportLink>

              <ReportLink href="/all-sickness" group={groups.OPERATIONS} icon="clinic-medical">
                All Sickness
              </ReportLink>
            </Card.Body>
          </Card>
        </Col>
      </RestrictedContent>

      <Col md={4}>
        <Card className="mb-4">
          <Card.Header>Out of Hours</Card.Header>
          <Card.Body>
            <CsrfContext.Consumer>
              {(csrfToken) => (
                <>
                  <SupportCsv groups={groups} csrfToken={csrfToken} />
                  <SupportEmail groups={groups} csrfToken={csrfToken} />
                </>
              )}
            </CsrfContext.Consumer>
          </Card.Body>
        </Card>
      </Col>

      <Col md={4}>
        <Card className="mb-4">
          <Card.Header>Task Runner</Card.Header>
          <Card.Body>
            <CsrfContext.Consumer>
              {(csrfToken) => (
                <TaskRunner csrfToken={csrfToken} />
              )}
            </CsrfContext.Consumer>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

function ReportLink({
  group,
  href,
  children,
  icon,
}) {
  return (
    <RestrictedContent group={group}>
      <a className="btn btn-block btn-outline-primary mb-2 text-left" href={href}>
        <Icon icon={icon} variant="fad" append="mr-2" />
        {children}
      </a>
    </RestrictedContent>
  );
}

export default Reports;
